import {Route} from "react-router-dom";
import {lazy} from "react";
import UrlsConfig from "@/config/UrlsConfig";

const RecordingToPartners = lazy(() => import("@/pages/ControlPanel/Nested/Statistics/RecordingsToPartners/RecordingToPartners"));
const AppealsStats = lazy(() => import("@/pages/ControlPanel/Nested/Statistics/Appeals/Appeals"));
const ResponseTime = lazy(() => import("@/pages/ControlPanel/Nested/Statistics/ResponseTime/ResponseTime"));
const TicketMessageParsingStats = lazy(() => import(
    "@/pages/ControlPanel/Nested/Statistics/TicketMessageParsing/TicketMessageParsingStats"
));
const TicketPartnerRatingStats = lazy(() => import(
    "@/pages/ControlPanel/Nested/Statistics/TicketPartnerRating/TicketPartnerRatingStats"
));

const urlsConfig = new UrlsConfig();

export function statisticsRoutes() {
    return (
      <>
          <Route path={urlsConfig.statsRecordingsToPartners.to} element={<RecordingToPartners/>}/>
          <Route path={urlsConfig.statsAppeals.to} element={<AppealsStats/>}/>
          <Route path={urlsConfig.responseTime.to} element={<ResponseTime/>}/>
          <Route
              path={urlsConfig.statsTicketMessageParsing.to}
              element={<TicketMessageParsingStats/>}
          />
          <Route
              path={urlsConfig.statsAppealsPartnerRating.to}
              element={<TicketPartnerRatingStats/>}
          />
      </>
    );
}
